import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { MfRouteComponentLoader } from 'shared/helpers/mf-component-loader'
import { FeatureFlags } from 'core/constants'
import { IAppState } from 'core/store/store'
import { RouterConfig } from 'core/utils/constants'
import History from 'core/history/history'
import PageNotFound from 'secure-pages/page-not-found/PageNotFound'
import { Spinner } from '@digicert/dcone-common-ui'
import { useLocalStorageUrl } from 'shared/helpers/useLocalStorageUrl'

const UnifiedUserManagement = () => {
  // isLoading is undefined before the first fetch and true during fetch; treat both as loading
  const isFeaturesLoading = useSelector((state: IAppState) =>
    state.features.isLoading !== false
  )
  const isUnifiedRoleActive = useSelector((state: IAppState) =>
    !!(state.features as any)?.[FeatureFlags.ENABLE_UNIFIED_USER_MANAGEMENT]
  )

  const persistentHeaderUrl = useLocalStorageUrl(
    'persistent_header_url',
    'https://unified-platform.digicert.com'
  )

  const additionalParams = useMemo(() => ({
    noAppPrefix: true,
    onNavigate: (browserPath: string) => {
      if (History.location.pathname === browserPath) return
      History.replace(browserPath)
    },
    mfeBasePath: RouterConfig.urlMap.unifiedUserManagement,
    persistentHeaderUrl: persistentHeaderUrl,
    disableLoader: true
  }), [persistentHeaderUrl])

  if (isFeaturesLoading) {
    return <Spinner />
  }

  if (!isUnifiedRoleActive) {
    return <PageNotFound />
  }

  return (
    <>
      <MfRouteComponentLoader
        containerId={'unifiedUserManagement'}
        microAppName={'user-access-management-mfe'}
        manifestDomain={persistentHeaderUrl}
        additionalParams={additionalParams}
      />
    </>
  )
}

export default UnifiedUserManagement
